import React, { useContext, useEffect, useState } from "react";
import { secured } from "react-abac";
import { AnimClassEnum, AnimOrderEnum, AuthoritiesEnum, CRUDActionEnum } from "~/types/enums";
import RestrictedSection from "~/components/RestrictedSection";
import { useTranslation } from "react-i18next";
import CoreContext from "~/lib/context";
import { Section, Text, Modal, Button, Icon } from "~/components-shared";
import ErrorBoundaryCard from "~/components/ErrorBoundaryCard";
import CompanyIntegrations from "~/components/CompanyIntegrations";
import useAbacExt from "~/hooks/abac";
import ShareIntegrationsModal from "~/components/ShareIntegrationsModal";
import styled from "styled-components";
import IntegrationsSidebar from "~/components/IntegrationsSidebar";
import ApiTokenCreateModal from "~/components/ApiTokenCreateModal";
import { useSelector } from "react-redux";
import apiTokenSelectors from "~/store/apiTokens/selectors";
const StyledButton = styled(Button)`
  float: right;
`;
const Integrations = () => {
  const {
    t
  } = useTranslation();
  const {
    setSidebar
  } = useContext(CoreContext);
  const [shareIntegrations, setShareIntegrations] = useState(false);
  const tokenAction = useSelector(apiTokenSelectors.getAction);
  const {
    userHas
  } = useAbacExt();
  useEffect(() => {
    setSidebar(/*#__PURE__*/React.createElement(IntegrationsSidebar, null));
  }, [setSidebar]);
  const handleShareIntegrations = () => {
    setShareIntegrations(true);
  };
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Text, {
    element: "h1",
    s: {
      mt: 5,
      mb: 8
    },
    className: `${AnimOrderEnum.ONE} ${AnimClassEnum.POP_RIGHT_FADE}`
  }, t("Integrations.integrations"), userHas(AuthoritiesEnum.INTEGRATIONS_WRITE) && /*#__PURE__*/React.createElement(StyledButton, {
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "send",
      s: {
        mr: 2
      }
    }),
    color: "primary",
    s: {
      px: 4,
      py: 2,
      mt: 3
    },
    fontSize: 3.5,
    lineHeight: 5,
    onClick: handleShareIntegrations
  }, t("Integrations.shareWithIT"))), /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, /*#__PURE__*/React.createElement(CompanyIntegrations, {
    showSoc2Logo: true
  })), userHas(AuthoritiesEnum.INTEGRATIONS_WRITE) && /*#__PURE__*/React.createElement(Modal, {
    open: shareIntegrations
  }, /*#__PURE__*/React.createElement(ShareIntegrationsModal, {
    onClose: () => setShareIntegrations(false)
  })), userHas(AuthoritiesEnum.PROFILE_WRITE) && /*#__PURE__*/React.createElement(Modal, {
    open: tokenAction === CRUDActionEnum.CREATE
  }, /*#__PURE__*/React.createElement(ApiTokenCreateModal, null)));
};
export default /*#__PURE__*/React.memo(secured({
  permissions: AuthoritiesEnum.INTEGRATIONS_READ,
  noAccess: () => /*#__PURE__*/React.createElement(RestrictedSection, null)
})(Integrations), () => true);